import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/default/header";
import LeadReport from "./leadReport";
import LeadList from "./leadList";
import SidebarMenu from "./menu/sidebarMenu";
import Breadcrumb from "../default/breadcrumb/breadcrumb";

const CardLead = () => {
    return (
        <div className="content-wrapper sidebar-menu-enable">
            <Helmet><title>Lead - Cardiast</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
               <SidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <LeadList />
                </div>
            </div>
        </div>
    );
}

export default CardLead;